module.exports = __webpack_public_path__ + "img/notice-icon.440eeb4e.png";